import { Box } from '@spark-web/box';
import { Spinner } from '@spark-web/spinner';

export const LoadingPlaceholder = () => (
  <Box display="flex" justifyContent="center" alignItems="center" height="full" paddingY="xxxlarge">
    <Spinner />
  </Box>
);
